export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    fixed: 'left',
    slots: {
      default: 'opt'
    }
  },
  {
    headerAlign: 'center',
    field: 'gasCardNo',
    align: 'left',
    width: 170,
    title: '油卡卡号',
    fixed: 'left',
    sortable: true,
    sortType: 'String',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'gasStation',
    align: 'left',
    minWidth: 200,
    title: '开户加油站',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'purchaseDate',
    align: 'center',
    width: 120,
    title: '办卡日期',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    field: 'gasCardBalance',
    align: 'center',
    minWidth: 120,
    title: '油卡余额',
    sortable: true
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    minWidth: 220,
    title: '所属机构',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'useType',
    align: 'left',
    minWidth: 150,
    title: '领用类型',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'useName',
    align: 'left',
    minWidth: 200,
    title: '领用对象名称',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'gasCardRemarks',
    align: 'left',
    minWidth: 300,
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'gasCardStatusName',
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'String'
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'String'
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true
  }
]
